import Features from '../types/enums/features';
import User from '../classes/user';
import { store } from '../store/store';

const PlanUtils = {
  checkFeature(feature: Features, channelPlans?: string[]) {
    const {
      user: { extraPlans, planId, isTest },
    } = store.getState();

    // If the main plan or any of the user's extra plans
    // contains the given feature, it will become available
    // (if the channel allows it too)
    return (
      extraPlans?.find((item) => {
        if (channelPlans?.includes(item?.id || '')) {
          const planToEval = item.id ? User.getPlan(item.id) : null;
          return planToEval?.evaluateFeature(feature) ? planToEval : null;
        } else {
          return null;
        }
      }) ||
      (User.getPlan(planId)?.evaluateFeature(feature)
        ? User.getPlan(planId)
        : undefined) ||
      isTest
    );
  },
};

export default PlanUtils;
